import { render } from "./SelectData.vue?vue&type=template&id=61da8947"
import script from "./SelectData.vue?vue&type=script&lang=js"
export * from "./SelectData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__